import React from "react";
import {
  BarChart,
  Bar,
  ResponsiveContainer,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const CustomBar = (props) => {
  const { payload, ...rest } = props;
  const { dm_sent, dm_received } = payload;
  const total = dm_sent + dm_received;

  // Default to 0.5 if total is 0 (avoid NaN)
  const ratio = total > 0 ? dm_sent / total : 0.5;

  // Hue from 180 (received) to 60 (sent)
  const hue = 40 - ratio * 40;
  const fill = `hsl(${Math.floor(hue)}, 95%, 60%)`;

  return <Rectangle {...rest} fill={fill} className="recharts-bar-rectangle" radius={[3, 3, 0, 0]}/>;
};

const militaryToStandardTime = (militaryTime) => {
  let mTime = parseInt(militaryTime)
  if (mTime == 0) return "12AM"
  if (mTime < 12) return mTime.toString() + "AM"
  if (mTime == 12) return "12PM"
  if (mTime > 12) return (mTime % 12).toString() + "PM"
  return ""
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        {`${militaryToStandardTime(label)}: ${payload[0].value} Messages`}
      </div>
    );
  }
  return null;
};

const CustomCursor = props => {
  const { x, y, width, height, stroke } = props;
  return <Rectangle fill="#222" stroke="#222" x={x} y={y} width={width} height={height} />;
};

const MessageTimeOfDay = ({ timeOfDayData }) => {
  // Preprocess data to include total DMs
  const processedData = timeOfDayData.map((d) => ({
    ...d,
    dm_total: d.dm_sent + d.dm_received,
  }));

  return (
    <div className="container container-chart">
      <ResponsiveContainer width="100%" height={225}>
        <BarChart barCategoryGap="17%" data={processedData}>
          <CartesianGrid stroke="#222222" />
          <XAxis dataKey="hour" minTickGap={3} tickFormatter={(value) => militaryToStandardTime(value)} />
          <YAxis />
          <Tooltip 
            cursor={<CustomCursor />}
            content={<CustomTooltip />}
          />
          <Bar
            dataKey="dm_total"
            shape={<CustomBar />}
            isAnimationActive={false}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MessageTimeOfDay;
